package com.artvending.warden.screens.sending

import androidx.compose.runtime.Composable
import com.artvending.warden.Column_
import com.artvending.warden.MdCircularProgress
import com.artvending.warden.OutlinedButton
import com.artvending.warden.isGeolocationGetting
import com.artvending.warden.settings
import com.artvending.warden.language
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
actual fun Any?.SendingScreen(model: SendingScreenModel) {
	Div({ style { flexGrow(1) } })
	Column_({ style { alignSelf(AlignSelf.Stretch); gap(settings.space) } }) {
		Column_({ style { alignSelf(AlignSelf.Center); textAlign("center") } }) {
			if (isGeolocationGetting) {
				Div {
					Text(language.TIME_GOT)
				}
				Div {
					Text(language.GEOLOCATION_GETTING)
				}
			}
			else
				Text(language.DATA_SENDING)
			
		}
		MdCircularProgress { style { alignSelf(AlignSelf.Center) } }
		Div({classes(settings.titleFontClass); style{textAlign("center")}}) {
			Text(language.WAIT_FINISH)
		}
		OutlinedButton({ model.reset() }, { style { marginTop(settings.bigSpace); alignSelf(AlignSelf.Center) } }) {
			Text(language.CANCEL)
		}
	}
	Div({ style { flexGrow(1.5) } })
}